import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LoaderIcon } from '@repo/icons';
import {
  SettingsInlineButton,
  Section,
  SettingsSectionBox,
  SettingsSectionLabel,
} from '@views/Settings/components';
import { selectIntegrationByPlatform } from '@repo/redux/reducers/user/integrations';
import { updateIntegrationVersion } from '@repo/redux/actions/integrations';

export default function LIIntegrationVersion() {
  const dispatch = useDispatch();
  const integration = useSelector(selectIntegrationByPlatform('linkedin'));
  const [isUpdating, setIsUpdating] = useState(false);
  const [version, setVersion] = useState(0);

  const changeVersion = () => {
    dispatch(updateIntegrationVersion('linkedin', version));
  };

  useEffect(() => {
    setVersion(integration?.metadata?.version);
  }, [integration?.metadata?.version]);

  useEffect(() => {
    if (integration?.metadata?.version === version && isUpdating) {
      setIsUpdating(false);
    }
  }, [integration?.metadata?.version, version, isUpdating]);

  if (!integration || integration.isFetching) {
    return null;
  }

  return (
    <Section>
      <SettingsSectionLabel>LinkedIn Integration Version</SettingsSectionLabel>
      <SettingsSectionBox
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '10px 16px 12px',
        }}
      >
        <input
          type="number"
          value={version}
          onChange={(e) => setVersion(parseInt(e.target.value, 10))}
          disabled={isUpdating}
          min={1}
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--textPrimary)',
            width: 60,
          }}
        />
        <SettingsInlineButton onClick={changeVersion} disabled={isUpdating}>
          {isUpdating ? <LoaderIcon /> : 'Change Version'}
        </SettingsInlineButton>
      </SettingsSectionBox>
    </Section>
  );
}
